import React from 'react'
import { Box, Divider } from '@vp/swan'
import type { ProductOptionsConfiguratorData } from '@vp/product-options'

import ProductQuantitySelection from '../quantity/ProductQuantitySelection'
import { ProjectContextProvider } from '../root/contexts/ProjectContext'
import { useProjects } from '../root/contexts/ProjectsContext'
import { AddQuantityTitle } from './configuration/Title'

type ProjectsProps = {
  configuratorData?: ProductOptionsConfiguratorData
}

const Projects: React.FC<ProjectsProps> = ({ configuratorData }) => {
  const { projects } = useProjects()

  const hasProjects = projects && projects.length > 0

  return (
    <>
      <Box className="quantity-title" data-testid="add-quantity-title">
        <AddQuantityTitle />
      </Box>
      {hasProjects &&
        projects.map((project, index) => (
          <ProjectContextProvider key={`proj-${project.workId}`} project={project} projectNumber={index + 1} projectCount={projects.length}>
            {index !== 0 && <Divider mb="between-subsections" />}
            <ProductQuantitySelection configuratorData={configuratorData} />
          </ProjectContextProvider>
        ))}
    </>
  )
}

export default Projects
